import { store } from '../store/store'
import LogIn from '../components/LogIn'
import MainContainer from '../components/MainContainer'
import GroupsUsers from '../components/GroupsUsers'
import ShippingDisplay from '../components/ShippingDisplay'
import Detailing from '../components/Detailing'
import Statistic from '../components/Statistic'
import TechnicalSupportPackages from '../components/TechnicalSupportPackages'
import Packages from '../components/Packages'
import Reports from '../components/Reports'
import PiportalApiSearch from '../components/PiportalApiSearch'
import Consignments from '../components/Consignments'
import Demo from '../components/Demo'
import Lead from '../components/Lead'
import CompanyProfile from '../components/CompanyProfile'
import UserProfile from '../components/UserProfile'
// import DownloadClient from '../components/DownloadClient'
import FillBillNews from '../components/FillBillNews'
import PackageStatistic from '../components/PackageStatistic'
import PiTransitOtvt from '../components/PiTransitOtvt'
import ProductClient from '../components/ProductClient'
import OtvtOrganizations from '../components/OtvtOrganizations'
import ReportFixedPackages from '../components/ReportFixedPackages'

import PageNotFound from '../components/PageNotFound'

const ifAuthenticated = (to, from, next) => {
  if (store.getters['authorization/isAuthenticated']) {
    next()
    return
  }
  next('/login')
}

export const routes = [
  {
    path: '/',
    component: MainContainer,
    name: 'main-container',
    meta: { title: 'user', name: 'Личный кабинет' },
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: '/administration/organisations-users',
        component: GroupsUsers,
        name: 'organisations-users',
        meta: { title: 'user', name: 'Организации и пользователи' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/tablo',
        component: ShippingDisplay,
        name: 'shipping-display',
        meta: { title: 'user', name: 'Табло судозаходов' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/pi-transit',
        component: PiTransitOtvt,
        name: 'pi-transit',
        meta: { title: 'user', name: 'ПИ и транзит' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/piportal',
        component: PiportalApiSearch,
        name: 'piportal-api-search',
        meta: { title: 'user', name: 'Пакеты FILL-BILL' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/consignments',
        component: Consignments,
        name: 'consignments',
        meta: { title: 'user', name: 'Виртуальный пакет' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/detailing',
        component: Detailing,
        name: 'detailing',
        meta: { title: 'admin', name: 'Детализация' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/sales-statistic',
        component: Statistic,
        name: 'sales-statistic',
        meta: { title: 'user', name: 'Статистика продаж' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/report_fixed_packages',
        component: ReportFixedPackages,
        name: 'report_fixed_packages',
        meta: { title: 'user', name: 'Тариф минимальный' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/package-statistic',
        component: PackageStatistic,
        name: 'package-statistic',
        meta: { title: 'user', name: 'Статистика по пакетам' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/:name',
        component: Reports,
        name: 'reports',
        meta: { title: 'user', name: 'Отчеты' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/lead',
        component: Lead,
        name: 'lead',
        meta: { title: 'admin', name: 'Лиды' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/demo',
        component: Demo,
        name: 'demo',
        meta: { title: 'admin', name: 'Демо' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/company-profile',
        component: CompanyProfile,
        name: 'company-profile',
        meta: { title: 'admin', name: 'Профиль компании' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/user-profile',
        component: UserProfile,
        name: 'user-profile',
        meta: { title: 'admin', name: 'Профиль пользователя' },
        beforeEnter: ifAuthenticated
      },
      /* {
        path: '/download',
        component: DownloadClient,
        name: 'download',
        meta: { title: 'user', name: 'Скачать дистрибутив' },
        beforeEnter: ifAuthenticated
      }, */
      {
        path: '/site-fill-bill/categories',
        component: FillBillNews,
        name: 'fill-bill-categories',
        meta: { title: 'admin', name: 'Категории и записи' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/packages/list',
        component: Packages,
        name: 'packages-list',
        meta: { title: 'user', name: 'Список пакетов' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/support/packages',
        component: TechnicalSupportPackages,
        name: 'support-packages-list',
        meta: { title: 'user', name: 'Список пакетов для техподдержки' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/product/client',
        component: ProductClient,
        name: 'client',
        meta: { title: 'user', name: 'Скачать дистрибутив' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/otvt-groups-users',
        component: OtvtOrganizations,
        name: 'otvt-groups-users',
        meta: { title: 'user', name: 'Организации ОТВТ' },
        beforeEnter: ifAuthenticated
      }
    ]
  },
  {
    path: '/display',
    component: ShippingDisplay,
    name: 'shipping-display-external'
  },
  {
    path: '/login',
    component: LogIn,
    name: 'log-in'
  },
  {
    path: '*', component: PageNotFound
  }
]
